import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import AddHomeRoundedIcon from '@mui/icons-material/AddHomeRounded';
import { NotificationImportant } from '@mui/icons-material';
import EventAvailableRoundedIcon from '@mui/icons-material/EventAvailableRounded';
import PostAddRoundedIcon from '@mui/icons-material/PostAddRounded';
import ContactlessRoundedIcon from '@mui/icons-material/ContactlessRounded';
import { NavLink } from 'react-router-dom';

type Anchor = 'top' | 'left' | 'bottom' | 'right';

type props = {
    open: boolean,
    setOpen: Function
}

const MenuItem = [
    { text: 'Trang chủ', slug: '/', icon: <AddHomeRoundedIcon /> },
    { text: 'Thông báo', slug: 'notification', icon: <NotificationImportant /> },
    { text: 'Xem thời khóa biểu', slug: 'schedule', icon: <EventAvailableRoundedIcon /> },
    { text: 'Xem lịch thi', slug: 'exam', icon: <PostAddRoundedIcon /> },
    { text: 'Liên hệ', slug: 'contact', icon: <ContactlessRoundedIcon /> }

]

export default function MenuDrawer({ open, setOpen }: props) {
    const list = () => (
        <Box
            role="presentation"
        >
            <List>
                {MenuItem.map((item, index) => (
                    <ListItem onClick={()=> setOpen(false)}>
                        <NavLink to={`${item.slug}`}>
                            <Button startIcon={item.icon} sx={{ color: '#757575' }}>
                                {item.text}
                            </Button>
                        </NavLink>
                    </ListItem>
                ))}

            </List>
        </Box>
    );

    return (
        <div>
            <Drawer
                anchor={'left'}
                open={open}
                onClose={() => setOpen(false)}
            >
                {list()}
            </Drawer>
        </div>
    );
}